import ApiMethods from '../ApiMethods'
import ENDPOINTS from '../Endpoints'
import DrupalApiManager from './DrupalApiManager'

class BannersApiManager {
    static toggleActiveBanner = (nodeId, active) => {
        return ApiMethods.patch(ENDPOINTS.EDIT_NODE(nodeId), {
            type: [
                {
                    target_id: 'banner',
                },
            ],
            field_active_banner: {
                value: active,
            },
        })
    }

    static deleteBanner = (nodeId) => {
        return ApiMethods.delete(ENDPOINTS.DELETE_NODE(nodeId))
    }

    static updateBannerPosition = (nodeId, position) => {
        return ApiMethods.patch(ENDPOINTS.EDIT_NODE(nodeId), {
            type: [
                {
                    target_id: 'banner',
                },
            ],
            field_position: [
                {
                    value: position,
                },
            ],
        })
    }

    static editBanner = async (data) => {
        let dataToEdit = {
            type: [
                {
                    target_id: 'banner',
                },
            ],
            field_position: [
                {
                    value: data.field_position,
                },
            ],
            title: [{ value: data.title }],
            field_active_banner: [
                {
                    value: data.active,
                },
            ],
        }

        if (data.imageTv) {
            const imageTvResultFid = await DrupalApiManager.uploadFile(
                data.imageTv,
                'node',
                'banner',
                'field_imagen'
            )
            dataToEdit.field_imagen = [
                {
                    target_id: imageTvResultFid,
                },
            ]
        }

        if (data.imageMobile) {
            const imageMobileResultFid = await DrupalApiManager.uploadFile(
                data.imageMobile,
                'node',
                'banner',
                'field_imagen_para_telefonos_y_ta'
            )
            dataToEdit.field_imagen_para_telefonos_y_ta = [
                {
                    target_id: imageMobileResultFid,
                },
            ]
        }

        return ApiMethods.patch(ENDPOINTS.EDIT_NODE(data.nid), dataToEdit)
    }
    static createBanner = (data) => {
        return ApiMethods.post(ENDPOINTS.CREATE_NODE, {
            type: [
                {
                    target_id: 'banner',
                },
            ],
            field_position: [
                {
                    value: data.field_position,
                },
            ],
            title: [{ value: data.title }],
            field_imagen_para_telefonos_y_ta: [
                {
                    target_id: data.imageMobileFid,
                },
            ],
            field_imagen: [
                {
                    target_id: data.imageTvFid,
                },
            ],
            field_active_banner: [
                {
                    value: data.active,
                },
            ],
        })
    }

    static assignBannerToGroup = (nodeId) => {
        var operatorData = localStorage.getItem('operador')
        var { group_id } = JSON.parse(operatorData)
        return ApiMethods.post(ENDPOINTS.ASSIGN_CONTENT_TO_GROUP, {
            type: 'operators-group_node-banner',
            group_id: group_id,
            node_id: nodeId,
        })
    }
    
    static uploadAndSaveBanner = async (data) => {
        const imageMobileResultFid = await DrupalApiManager.uploadFile(
            data.imageMobile,
            'node',
            'banner',
            'field_imagen_para_telefonos_y_ta'
        )
        const imageTvResultFid = await DrupalApiManager.uploadFile(
            data.imageTv,
            'node',
            'banner',
            'field_imagen'
        )

        var bannerCreated = await this.createBanner({
            title: data.title,
            field_position: data.field_position,
            imageMobileFid: imageMobileResultFid,
            imageTvFid: imageTvResultFid,
            active: data.active,
        })

        return await this.assignBannerToGroup(bannerCreated.nid[0].value)
    }
}
export default BannersApiManager
